import post1En from "../assets/images/Blog/post1-en.png";
import post1Es from "../assets/images/Blog/post1-es.png";
import post2En from "../assets/images/Blog/post2-en.jpg";
import post2Es from "../assets/images/Blog/post2-es.jpg";

export const blogPosts = [
    {
        id: 1,
        es: {
            imagen: post1Es,
            slug: "seguridad-no-es-solo-software",
            titulo: "La seguridad no es solo software",
            descripcion: "El mantenimiento importa.Los fallos estructurales pueden costar millones.En 2011, un pequeño desajuste de sincronización en una red de cajeros automáticos permitió que una sola persona retirara 1, 6 millones de dólares australianos a lo largo de varios meses.Lo que parecía una inconsistencia menor del sistema se convirtió en una oportunidad masiva.Esta historia es un recordatorio: la disciplina operativa, la arquitectura de red y las actualizaciones oportunas son críticas para prevenir riesgos, fraudes y fallos sistémicos...",
            contenido: `
            <p>En 2011, Dan Saunders, un camarero de 29 años de Wangaratta (Australia), protagonizó uno de los exploits más inusuales en la historia de los cajeros automáticos. Salió de un bar buscando efectivo. Su cuenta no tenía dinero. El cajero, según el relato público, debía decirle “no”. Pero dijo “sí”. No una vez: varias.</p> <br>

            <p>Tras repetir la maniobra con pequeñas cantidades, comprendió que existía un desfase temporal entre las transacciones locales de los ATMs y la actualización del balance en el sistema central del banco, lo que le permitía “crear dinero” aprovechando esa ventana de inconsistencia.</p><br>

            <p>Lo que comenzó como una anomalía aislada terminó convirtiéndose en un patrón que se extendió durante aproximadamente cuatro meses y medio. En ese período, Dan Saunders logró retirar alrededor de 1,6 millones de dólares australianos —cerca de 900.000 euros— antes de que la culpa no lo dejara estar tranquilo y voluntariamente reportara el caso llegando así a instancias judiciales.</p><br>

            <p>Si uno busca el culpable en el lugar habitual, pensaría en un malware, un skimmer, un gabinete forzado. Pero el punto incómodo de esta historia es otro: <strong>no necesitas un atacante externo para romper un sistema, si el sistema tiene una ventana donde sus reglas se vuelven ambiguas.</strong></p><br>

            <p>Saunders, entrevistado años después, describe una mecánica basada en transferencias entre cuentas y en una franja horaria —entre la 1 y las 3 a.m., dice— en la que “los ATMs se van offline”, aparecen reversos posteriores y el balance “baila” como un yo-yo.</p><br>

            <p>Su historia es una advertencia más amplia: cuando una arquitectura opera por ventanas, lotes o desfases, el borde se vuelve un lugar fértil para el comportamiento atípico.</p><br>

            <p>No es un fenómeno exclusivo de un banco. Los sistemas de pago, incluso en países con infraestructura moderna, han convivido históricamente con liquidaciones por lotes y con momentos de cierre/compensación. La documentación indica que antes del RTGS, los procesos de liquidación podían consolidar obligaciones “al final del día” y liquidar al día siguiente (por ejemplo, a las 9:00 a.m.); y se describe que el sistema australiano incluye funcionalidad de <em>batch settlement</em> para posiciones netas.</p><br>

            <p>La lección práctica no es “los lotes son malos”. Es más concreta: <strong>El problema suele ser la suposición.</strong></p>
            <ul>
                <li>La suposición de que el usuario se comportará “promedio”.</li>
                <li>La suposición de que una ventana operativa no se convierte en patrón explotable.</li>
                <li>La suposición de que “si está arriba, está bien”.</li>
            </ul><br>

            <p>Ese último supuesto aparece todos los días en las redes ATM modernas. Una disponibilidad del 99,5% equivale a 43,8 horas anuales de indisponibilidad. Un 99,9%, a 8,76 horas. El problema no es el número. Es lo que oculta: no dice cuándo cae la indisponibilidad, ni bajo qué densidad transaccional, ni si la falla es “total” o apenas una degradación.</p><br>

            <p>Por eso, en prácticas de operación del canal, no se gobierna solo con un semáforo UP/DOWN. Se listan como KPIs habituales: tasas de error y reportes out-of-service, tiempos de respuesta, ratios transaccionales, SLAs y disponibilidad, entre otros. Es una forma de reconocer que el canal puede estar “arriba” y aún así perder dinero, reputación y confianza en silencio.</p><br>

            <p><strong>Disponibilidad no es impacto.</strong></p><br>

            <p>Y cuando uno se toma en serio esa frase, inevitablemente cae en un terreno que muchas organizaciones aún tratan como “anexo” de ciberseguridad: detección. En Cybersecurity Framework 2.0, la función Detect se define como la capacidad de descubrir y analizar a tiempo anomalías e indicadores de eventos adversos. El monitoreo continuo no se limita a “redes”, también contempla entorno físico, actividad de personal, servicios de terceros, hardware/software y datos.</p><br>

            <p>En el caso de Saunders, la desviación no era un exploit sofisticado. Era un patrón conductual repetido dentro de una ventana. Y lo verdaderamente estructural es que ese patrón pudo repetirse durante meses antes de convertirse en incidente formal. No porque el sistema estuviera caído, sino porque nadie estaba modelando el comportamiento límite. Lo que faltó no fue “antivirus”. Fue un modelo que detectara lo que el diseño no esperaba.</p><br>

            <h2>Aquí es donde la inteligencia artificial comienza a cambiar el terreno.</h2><br>

            <p>Tradicionalmente, los sistemas de monitoreo ATM enviaban alertas cuando algo ya estaba mal. La lógica era reactiva. La IA introduce una lógica distinta: analiza patrones de comportamiento e identifica desviaciones estadísticas. Aplicado al caso Saunders, un sistema inteligente habría podido:</p>
            <ul>
                <li>Detectar recurrencia inusual de retiros en una franja horaria específica.</li>
                <li>Correlacionar transferencias previas con extracciones posteriores.</li>
                <li>Identificar secuencias repetidas que se desvían del comportamiento promedio.</li>
                <li>Generar alertas basadas en patrón, no en caída técnica.</li>
            </ul><br>

            <p>Y eso cambia completamente la naturaleza del riesgo. <strong>La inteligencia artificial no reemplaza la arquitectura. La hace visible.</strong></p><br>

            <p>En mantenimiento ocurre algo similar. Hoy, los modelos inteligentes pueden analizar logs de error y patrones de uso para diagnosticar qué componente está en riesgo antes de que falle completamente. El sistema puede sugerir qué parte está comprometida, priorizar el evento y estructurar el ticket con datos relevantes. Incluso la asignación de técnicos puede optimizarse: identificar la certificación adecuada y calcular el tiempo estimado de llegada.</p><br>

            <p>Luego viene la capa que suele romper la calma de cualquier gerente de operaciones: el mantenimiento. Cada intervención correctiva implica apertura física, riesgo de error humano y consumo de capacidad. El BIA (Business Impact Analysis) es importante porque prioriza funciones y considera recursos críticos —incluyendo hardware, software, datos e infraestructura—.</p><br>

            <p>Traducido al mundo ATM: si tu SLM se vuelve un cuello de botella, la red no “se cae”; se satura.</p><br>

            <p><strong>La seguridad no es solo software.</strong> Es coherencia estructural entre:</p>
            <ul>
                <li>Autorización y liquidación (reglas y ventanas).</li>
                <li>Medición y comportamiento (KPIs que ven degradación).</li>
                <li>Mantenimiento y capacidad (backlog, partes, logística).</li>
                <li>Seguridad física y seguridad lógica (amenaza híbrida).</li>
            </ul><br>

            <p>Las guías PCI PTS ATM Security Guidelines son un recordatorio útil: hablan de mitigar ataques orientados a robar PIN/datos, pero incluyen hardening del OS, parches y protección física. Fraudes como el skimming “tradicional” demuestran que la frontera físico-digital es real y operativa.</p><br>

            <p>ATM Net ofrece mantenimiento multimarca, monitoreo de uptime, servicios de segunda línea (SLM), modalidad VOI (inventario del proveedor), capacitación (ATMnet School) y análisis forense. La “seguridad” de una red ATM depende de si las capas están alineadas y si la operación puede anticipar.</p><br>

            <p><strong>La seguridad no es solo software. Es diseño. Es operación. Es mantenimiento. Es capacidad.</strong></p><br>

            <p>En ATMnet somos expertos. Si quieres evaluar tu red con esta lógica de capas, solicita un diagnóstico integral con nosotros. Si tu reto está en SLM e inventario, explora una modalidad VOI. Y si tu cuello de botella es entrenamiento, revisa opciones de capacitación multimarca (ATMnet School).</p><br>

            <h3>Bibliografía y fuentes externas</h3><br>
            <ul style="color: blue;">
                <li><a href="https://www.bbc.com/news" target="_blank" rel="noopener noreferrer">BBC News – Reportes sobre el caso Dan Saunders (2011 ATM glitch)</a></li>
                <li><a href="https://www.rba.gov.au/payments-and-infrastructure/rits/" target="_blank" rel="noopener noreferrer">Reserve Bank of Australia – RITS (Reserve Bank Information and Transfer System)</a></li>
                <li><a href="https://www.nist.gov/cyberframework" target="_blank" rel="noopener noreferrer">NIST – Cybersecurity Framework 2.0</a></li>
                <li><a href="https://ithandbook.ffiec.gov/it-booklets/business-continuity-management.aspx" target="_blank" rel="noopener noreferrer">FFIEC – IT Examination Handbook: Business Continuity Management</a></li>
                <li><a href="https://www.pcisecuritystandards.org/document_library/" target="_blank" rel="noopener noreferrer">PCI Security Standards Council – ATM Security Guidelines</a></li>
                <li><a href="https://www.incibe.es" target="_blank" rel="noopener noreferrer">INCIBE – Información sobre fraudes como skimming</a></li>
            </ul>
            `
        },
        en: {
            imagen: post1En,
            slug: "security-is-not-just-software",
            titulo: "Security is not just software",
            descripcion: "Maintenance matters.Structural flaws can cost millions.In 2011, a small timing mismatch in an ATM network allowed a single person to withdraw AUD 1.6 million over several months.What seemed like a minor system inconsistency became a massive opportunity.This story is a reminder: operational discipline, network architecture, and timely updates are critical to prevent risk, fraud, and systemic failures.",
            contenido: `
            <p>In 2011, Dan Saunders, a 29-year-old bartender from Wangaratta, Australia, carried out one of the most unusual exploits in ATM history. He left a bar looking for cash, but his account was empty. According to public accounts, the ATM should have said "no," but it said "yes"—not just once, but several times.</p> <br>

            <p>After repeating the maneuver with small amounts, he realized there was a time lag between the local ATM transactions and the balance updates in the bank's central system. This allowed him to "create money" by taking advantage of that window of inconsistency.</p><br>

            <p>What began as an isolated anomaly turned into a pattern that lasted for approximately four and a half months. During that period, Dan Saunders managed to withdraw around 1.6 million Australian dollars—nearly 900,000 euros—before his guilt prevented him from being at peace, leading him to voluntarily report the case and eventually face judicial proceedings.</p><br>

            <p>If you look for the culprit in the usual places, you'd think of malware, a skimmer, a forced cabinet. But the uncomfortable point of this story is something else: <strong>you don't need an external attacker to break into a system if the system has a window where its rules become ambiguous.</strong></p><br>

            <p>Saunders, interviewed years later, describes a mechanism based on transfers between accounts and a time frame —between 1 and 3 am, he says— in which “ATMs go offline”, subsequent reversals appear and the balance “dances” like a yo-yo.</p><br>

            <p>Their story is a broader warning: when an architecture operates by windows, lots, or offsets, the edge becomes a fertile ground for atypical behavior.</p><br>

            <p>This is not a phenomenon exclusive to one bank. Payment systems, even in countries with modern infrastructure, have historically coexisted with batch settlements and closing/clearing times. The document states that prior to RTGS, settlement processes could consolidate obligations "at the end of the day" and settle the following day (for example, at 9:00 am); and it describes that the Australian system includes batch settlement functionality for net positions.</p><br>

            <p>The practical lesson isn't "the batches are bad." It's more concrete: The problem is usually the assumption. The assumption that the user will behave “averagely.” The assumption that an operational window won't become an exploitable pattern. The assumption that “if it's up, it's fine.”</p><br>

            <p>That last assumption appears every day in modern ATM networks. A 99.5% availability equates to 43.8 hours of downtime per year. A 99.9% availability equates to 8.76 hours. The problem isn't the number itself. It's what it obscures: it doesn't say when the downtime occurs, at what transaction density, or whether the failure is "total" or merely a degradation.</p><br>

            <p>Therefore, channel operations are not governed solely by an UP/DOWN traffic light system. A sponsored guide lists common KPIs such as error rates and out-of-service reports, response times, transactional ratios, SLAs, and availability, among others. It's a way of acknowledging that the channel can be "on top" and still silently lose money, reputation, and trust.</p><br>

            <p><strong>Availability is not impact.</strong></p><br>

            <p>And when one takes that phrase seriously, one inevitably falls into a territory that many organizations still treat as an "annex" of cybersecurity: detection. In Cybersecurity Framework 2.0, the Detect function is defined as the ability to discover and analyze anomalies and indicators of adverse events in a timely manner. And something key for the ATM world: continuous monitoring is not limited to "networks," it also encompasses the physical environment, personnel activity, third-party services, hardware/software, and data.</p><br>

            <p>In Saunders' case, the deviation wasn't a sophisticated exploit. It was a recurring behavioral pattern within a specific window. And what's truly structural is that this pattern was able to repeat itself for months before becoming a formal incident. Not because the system was down, but because no one was modeling the boundary behavior. What was missing wasn't "antivirus". It was a model that could detect what the design didn't anticipate.</p><br>

            <h2>This is where artificial intelligence begins to change the landscape.</h2><br>

            <p>Traditionally, ATM monitoring systems sent alerts only when something was already wrong: a module out of service, a communication failure, a critical error. The logic was reactive. AI introduces a different logic: it analyzes behavioral patterns, identifies statistical deviations, and can anticipate failures before they impact the user or generate a service call.</p><br>

            <p>Applied to the Saunders case, a system with intelligent analysis could have:</p>
            <ul>
                <li>Detected unusual recurrence of withdrawals in a specific time frame.</li>
                <li>Correlated previous transfers with subsequent withdrawals.</li>
                <li>Identified repeated sequences that deviate from average behavior.</li>
                <li>Generated alerts based on pattern, not on technical decline.</li>
            </ul>

            <p>And that completely changes the nature of the risk. Artificial intelligence does not replace architecture. It makes it visible.</p><br>

            <p>Something similar happens in maintenance. Today, intelligent models can analyze error logs, sensor data, and usage patterns to diagnose which component is at risk before it fails completely. The system not only reports that something has failed; it can suggest which part is compromised, prioritize the event, and structure the ticket with relevant data.</p><br>

            <p>Even the allocation of technicians can be optimized: identifying who has the appropriate certification, calculating the estimated arrival time, and verifying the availability of spare parts to increase the first solution rate. It's not superficial automation. It's about moving from repairing when something breaks to anticipating when something starts to go astray.</p><br>

            <p>Then comes the layer that usually breaks the calm of any operations manager: maintenance. Each corrective intervention involves physically opening the cabinet, handling critical modules, risking human error, and, above all, consuming capacity. The problem isn't an isolated failure. It's synchronization: multiple nodes degrading under similar conditions (peaks, weather, telecom issues, wear and tear, obsolescence).</p><br>

            <p>This is where a classic principle of continuity comes in: it is not enough to "recover"; you have to know if your response capacity can withstand the scenario. Business Impact Analysis (BIA) is important because it prioritizes functions, analyzes interdependencies, defines recovery priorities, and considers critical resources—including hardware, software, data, infrastructure, and third parties.</p><br>

            <p>Translated to the ATM world: if your SLM becomes a bottleneck, the network doesn't "go down"; it gets saturated.</p>

            <p><strong>Security is not just software.</strong> It is structural coherence between:</p>
            <ul>
                <li>Authorization and settlement (rules and windows).</li>
                <li>Measurement and behavior (KPIs that show degradation).</li>
                <li>Maintenance and capacity (backlog, parts, logistics).</li>
                <li>Physical and logical security (hybrid threat).</li>
            </ul><br>

            <p>The PCI PTS ATM Security Guidelines talk about mitigating attacks aimed at stealing PINs/data, but include aspects such as OS hardening, patching, and protecting communication interfaces. Frauds like "traditional" skimming have historically occurred at ATMs. In other words, the physical-digital boundary is real and operational, not theoretical.</p><br>

            <p>ATM Net offers multi-brand maintenance, uptime monitoring, SLM, VOI mode, training (ATMnet School), and forensic analysis. This aligns with the article's thesis: the "security" of an ATM network depends on whether the layers are aligned and whether the operation can anticipate problems.</p><br>

            <p><strong>Security is not just software. It's design. It's operation. It's maintenance. It's capability.</strong></p><br>

            <p>At ATMnet we are experts. If you want to evaluate your network using this layered approach, request a comprehensive diagnostic from us. If your challenge lies in SLM and inventory, explore a VOI model. And if your bottleneck is training, check out our multi-vendor training options (ATMnet School).</p><br>

            <h3>Bibliography and external sources</h3> <br>
            <ul style="color: blue;">
                <li><a href="https://www.bbc.com/news" target="_blank" rel="noopener noreferrer">BBC News – Reports on the Dan Saunders case (2011 ATM glitch)</a></li>
                <li><a href="https://www.rba.gov.au/payments-and-infrastructure/rits/" target="_blank" rel="noopener noreferrer">Reserve Bank of Australia – RITS (Reserve Bank Information and Transfer System)</a></li>
                <li><a href="https://www.nist.gov/cyberframework" target="_blank" rel="noopener noreferrer">NIST – Cybersecurity Framework 2.0</a></li>
                <li><a href="https://ithandbook.ffiec.gov/it-booklets/business-continuity-management.aspx" target="_blank" rel="noopener noreferrer">FFIEC – IT Examination Handbook: Business Continuity Management</a></li>
                <li><a href="https://www.pcisecuritystandards.org/document_library/" target="_blank" rel="noopener noreferrer">PCI Security Standards Council – ATM Security Guidelines</a></li>
                <li><a href="https://www.incibe.es" target="_blank" rel="noopener noreferrer">INCIBE – Information on frauds such as skimming</a></li>
            </ul>
            `
        }
    },
    {
        id: 2,
        es: {
            imagen: post2Es,
            slug: "seguridad-mantenimiento-control-operativo-redes-atm",
            titulo: "Seguridad, mantenimiento y control operativo en redes ATM",
            descripcion: "La seguridad en cajeros automáticos se refiere al conjunto de controles, procesos y tecnologías diseñados para proteger los equipos frente a fraudes, ciberataques, manipulaciones físicas y fallas operativas. En las redes ATM modernas, la seguridad no se limita al software: incluye hardware, control de accesos físicos, mantenimiento, monitoreo y gobernanza operativa.",
            contenido: `
            <h2><strong>¿Qué es la seguridad en cajeros automáticos (ATM)?</strong></h2><br>

            <p>La seguridad en cajeros automáticos (ATM) se refiere al conjunto de controles, procesos y tecnologías diseñados para proteger los equipos frente a fraudes, ciberataques, manipulaciones físicas y fallas operativas.</p><br>

            <p>En las redes ATM modernas, la seguridad no se limita al software. Incluye también el hardware, el control de accesos físicos, los procesos de mantenimiento, el monitoreo y la gobernanza operativa.</p><br>

            <h2><strong>La seguridad en ATM no es solo software</strong></h2><br>

            <p>Cuando se habla de seguridad en cajeros automáticos, la conversación suele centrarse en:</p>
            <ul>
                <li>Endurecimiento del sistema operativo.</li>
                <li>Cifrado.</li>
                <li>Protección de endpoints.</li>
                <li>Gestión de parches.</li>
            </ul><br>

            <p>Estos controles son esenciales. Sin embargo, no definen completamente la superficie de riesgo de una red ATM.</p><br>

            <p>Las redes ATM son sistemas ciberfísicos. Combinan:</p>
            <ul>
                <li>Componentes de hardware.</li>
                <li>Plataformas de software.</li>
                <li>Puntos de acceso físico.</li>
                <li>Operaciones de mantenimiento.</li>
                <li>Intervención humana en campo.</li>
            </ul><br>

            <p>Este enfoque coincide con marcos como el NIST Cybersecurity Framework, que define la seguridad como un proceso continuo de identificación, protección, detección, respuesta y recuperación.</p><br>

            <h2><strong>Por qué fallan las redes ATM: no solo por ataques, sino por la operación</strong></h2><br>

            <p>Muchos incidentes en redes ATM no se originan en ciberataques sofisticados.</p><br>

            <p>Se originan en brechas operativas como:</p>
            <ul>
                <li>Acceso físico mal controlado.</li>
                <li>Mantenimiento reactivo.</li>
                <li>Falta de trazabilidad en intervenciones de campo.</li>
                <li>Actualizaciones tardías o sistemas fuera de soporte.</li>
                <li>Falta de visibilidad durante caídas del servicio.</li>
            </ul><br>

            <p>Una red puede ser técnicamente “cumplida” y aun así ser frágil.</p><br>

            <p>En infraestructura financiera, la fragilidad es un riesgo de seguridad.</p><br>

            <h2><strong>El downtime en ATMs es un problema de seguridad</strong></h2><br>

            <p>La indisponibilidad de cajeros automáticos suele tratarse como un problema de servicio. En realidad, impacta directamente la seguridad.</p><br>

            <p>Cuando un ATM queda fuera de servicio:</p>
            <ul>
                <li>Disminuye la visibilidad del monitoreo.</li>
                <li>Se debilita la detección de anomalías.</li>
                <li>Aumenta la presión operativa.</li>
                <li>Se incrementan las intervenciones manuales.</li>
            </ul><br>

            <p>De acuerdo con lineamientos de resiliencia como los del FFIEC, la disponibilidad y la continuidad son componentes críticos de la seguridad en sistemas financieros.</p><br>

            <p>La disponibilidad no debería medirse solo como “UP/DOWN”, sino a partir de:</p>
            <ul>
                <li>Transacciones fallidas.</li>
                <li>Tiempo de detección.</li>
                <li>Tiempo de recuperación en momentos de alta demanda.</li>
            </ul><br>

            <h2><strong>El acceso físico es un riesgo de ciberseguridad en ATM</strong></h2><br>

            <p>En entornos ATM, el acceso físico es uno de los eventos más críticos desde el punto de vista de seguridad.</p><br>

            <p>Cuando se abre un cajero automático, pueden quedar expuestos:</p>
            <ul>
                <li>Puertos internos.</li>
                <li>Dispositivos de almacenamiento.</li>
                <li>Controladores.</li>
                <li>Interfaces de servicio.</li>
            </ul><br>

            <p>Organizaciones como el PCI Security Standards Council destacan la importancia de controlar tanto el acceso físico como el lógico en estos sistemas.</p><br>

            <p>Por eso, cada intervención debe gestionarse mediante:</p>
            <ul>
                <li>Autorización.</li>
                <li>Trazabilidad mediante órdenes de trabajo.</li>
                <li>Validación de identidad.</li>
                <li>Evidencia de la intervención.</li>
                <li>Verificación posterior al mantenimiento.</li>
            </ul><br>

            <h2><strong>El mantenimiento de ATMs es un control de seguridad</strong></h2><br>

            <p>El mantenimiento en cajeros automáticos no es solo una función técnica. Es un control de seguridad.</p><br>

            <p>Cada intervención modifica:</p>
            <ul>
                <li>La superficie de ataque.</li>
                <li>La estabilidad operativa.</li>
                <li>La trazabilidad de los eventos.</li>
            </ul><br>

            <p>El mantenimiento preventivo permite reducir:</p>
            <ul>
                <li>Fallas inesperadas.</li>
                <li>Intervenciones de emergencia.</li>
                <li>Exposición no controlada.</li>
            </ul><br>

            <p>Un modelo de mantenimiento disciplinado mejora tanto la disponibilidad como la postura de seguridad.</p><br>

            <h2><strong>Cómo la inteligencia artificial mejora la seguridad y el mantenimiento en ATMs</strong></h2><br>

            <p>La inteligencia artificial en redes ATM mejora la toma de decisiones operativas.</p><br>

            <p>Permite:</p>
            <ul>
                <li>Detectar anomalías a partir de patrones.</li>
                <li>Anticipar fallas mediante mantenimiento predictivo.</li>
                <li>Priorizar intervenciones según impacto.</li>
                <li>Reducir accesos innecesarios en campo.</li>
            </ul><br>

            <p>En lugar de reaccionar a fallas, la IA permite anticiparlas.</p><br>

            <p>Esto reduce la incertidumbre, uno de los principales factores de riesgo operativo.</p><br>

            <h2><strong>La seguridad en ATM debe medirse por impacto, no solo por estado</strong></h2><br>

            <p>Las métricas tradicionales se enfocan en:</p>
            <ul>
                <li>Disponibilidad vs indisponibilidad.</li>
                <li>Cumplimiento de SLA.</li>
            </ul><br>

            <p>Sin embargo, estas métricas son insuficientes.</p><br>

            <p>Una medición efectiva de la seguridad en ATM debe incluir:</p>
            <ul>
                <li>Interacciones fallidas.</li>
                <li>Impacto en las transacciones.</li>
                <li>Desempeño en la recuperación.</li>
                <li>Patrones repetitivos de incidentes.</li>
            </ul><br>

            <p>Este enfoque está alineado con prácticas promovidas por organizaciones como la ATM Industry Association.</p><br>

            <h3><strong>Bibliografía y fuentes externas</strong></h3><br>
            <ul style="color: blue;">
                <li><a href="https://www.nist.gov/cyberframework" target="_blank" rel="noopener noreferrer">NIST – Cybersecurity Framework</a></li>
                <li><a href="https://ithandbook.ffiec.gov/it-booklets/business-continuity-management.aspx" target="_blank" rel="noopener noreferrer">FFIEC – Business Continuity Management</a></li>
                <li><a href="https://www.pcisecuritystandards.org/document_library/" target="_blank" rel="noopener noreferrer">PCI Security Standards Council – ATM Security Guidelines</a></li>
                <li><a href="https://www.atmia.com/" target="_blank" rel="noopener noreferrer">ATM Industry Association</a></li>
            </ul>
        `
        },
        en: {
            imagen: post2En,
            slug: "atm-security-maintenance-and-operational-control",
            titulo: "ATM Security, Maintenance, and Operational Control",
            descripcion: "ATM security refers to the set of controls, processes, and technologies used to protect automated teller machines from fraud, cyberattacks, physical tampering, and operational failures. In modern ATM networks, security is not limited to software. It includes hardware, physical access, maintenance processes, monitoring, and operational governance.",
            contenido: `
            <h2><strong>What is ATM security?</strong></h2><br>

            <p>ATM security refers to the set of controls, processes, and technologies used to protect automated teller machines (ATMs) from fraud, cyberattacks, physical tampering, and operational failures.</p><br>

            <p>In modern ATM networks, security is not limited to software. It includes hardware, physical access, maintenance processes, monitoring, and operational governance.</p><br>

            <h2><strong>ATM security is not just software</strong></h2><br>

            <p>When people talk about ATM security, the conversation often focuses on:</p>
            <ul>
                <li>Operating system hardening.</li>
                <li>Encryption.</li>
                <li>Endpoint protection.</li>
                <li>Patch management.</li>
            </ul><br>

            <p>These controls are essential. However, they do not fully define the risk surface of an ATM network.</p><br>

            <p>ATM networks are cyber-physical systems. They combine:</p>
            <ul>
                <li>Hardware components.</li>
                <li>Software platforms.</li>
                <li>Physical access points.</li>
                <li>Maintenance operations.</li>
                <li>Human intervention in the field.</li>
            </ul><br>

            <p>This aligns with frameworks such as the NIST Cybersecurity Framework, which defines security as a continuous process across identification, protection, detection, response, and recovery.</p><br>

            <h2><strong>Why ATM networks fail: not just attacks, but operations</strong></h2><br>

            <p>Many ATM incidents do not originate from advanced cyberattacks.</p><br>

            <p>They originate from operational gaps:</p>
            <ul>
                <li>Poorly controlled physical access.</li>
                <li>Reactive maintenance.</li>
                <li>Lack of traceability in field interventions.</li>
                <li>Delayed updates or unsupported systems.</li>
                <li>Lack of visibility during downtime.</li>
            </ul><br>

            <p>A network can be compliant and still be fragile.</p><br>

            <p>In financial infrastructure, fragility is a security risk.</p><br>

            <h2><strong>Downtime in ATMs is a security issue</strong></h2><br>

            <p>ATM downtime is often treated as a service problem. In reality, it directly affects security.</p><br>

            <p>When an ATM goes offline:</p>
            <ul>
                <li>Monitoring visibility decreases.</li>
                <li>Anomaly detection weakens.</li>
                <li>Operational pressure increases.</li>
                <li>Manual intervention becomes more frequent.</li>
            </ul><br>

            <p>According to guidance aligned with resilience practices such as those from the FFIEC, availability and continuity are critical components of financial system security.</p><br>

            <p>ATM uptime should not be measured only as “UP/DOWN”, but through:</p>
            <ul>
                <li>Failed transactions.</li>
                <li>Detection time.</li>
                <li>Recovery time under peak demand.</li>
            </ul><br>

            <h2><strong>Physical access is a cybersecurity risk in ATMs</strong></h2><br>

            <p>In ATM environments, physical access is one of the most critical security events.</p><br>

            <p>Once an ATM cabinet is opened, it may expose:</p>
            <ul>
                <li>Internal ports.</li>
                <li>Storage devices.</li>
                <li>Controllers.</li>
                <li>Service interfaces.</li>
            </ul><br>

            <p>Organizations such as the PCI Security Standards Council highlight the importance of controlling both physical and logical access to ATM systems.</p><br>

            <p>That is why every intervention must be governed through:</p>
            <ul>
                <li>Authorization.</li>
                <li>Work order traceability.</li>
                <li>Identity validation.</li>
                <li>Evidence of intervention.</li>
                <li>Post-maintenance verification.</li>
            </ul><br>

            <h2><strong>ATM maintenance is a security control</strong></h2><br>

            <p>ATM maintenance is not just a technical function. It is a security control.</p><br>

            <p>Every maintenance action changes:</p>
            <ul>
                <li>The attack surface.</li>
                <li>The operational stability.</li>
                <li>The traceability of events.</li>
            </ul><br>

            <p>Preventive maintenance reduces:</p>
            <ul>
                <li>Unexpected failures.</li>
                <li>Emergency interventions.</li>
                <li>Uncontrolled exposure.</li>
            </ul><br>

            <p>A disciplined maintenance model improves both uptime and security posture.</p><br>

            <h2><strong>How AI improves ATM security and maintenance</strong></h2><br>

            <p>Artificial intelligence in ATM networks improves operational decision-making.</p><br>

            <p>It enables:</p>
            <ul>
                <li>Anomaly detection based on patterns.</li>
                <li>Predictive maintenance.</li>
                <li>Prioritization of interventions.</li>
                <li>Reduction of unnecessary field access.</li>
            </ul><br>

            <p>Instead of reacting to failures, AI helps anticipate them.</p><br>

            <p>This reduces uncertainty, which is a key factor in operational risk.</p><br>

            <h2><strong>ATM security should be measured by impact, not status</strong></h2><br>

            <p>Traditional ATM metrics focus on status:</p>
            <ul>
                <li>Uptime vs downtime.</li>
                <li>SLA compliance.</li>
            </ul><br>

            <p>However, these metrics are insufficient.</p><br>

            <p>Effective ATM security measurement includes:</p>
            <ul>
                <li>Failed interactions.</li>
                <li>Transaction impact.</li>
                <li>Recovery performance.</li>
                <li>Repeat incident patterns.</li>
            </ul><br>

            <p>This approach aligns with industry practices promoted by organizations such as the ATM Industry Association.</p><br>

            <h3><strong>Bibliography and external sources</strong></h3><br>
            <ul style="color: blue;">
                <li><a href="https://www.nist.gov/cyberframework" target="_blank" rel="noopener noreferrer">NIST – Cybersecurity Framework</a></li>
                <li><a href="https://ithandbook.ffiec.gov/it-booklets/business-continuity-management.aspx" target="_blank" rel="noopener noreferrer">FFIEC – Business Continuity Management</a></li>
                <li><a href="https://www.pcisecuritystandards.org/document_library/" target="_blank" rel="noopener noreferrer">PCI Security Standards Council – ATM Security Guidelines</a></li>
                <li><a href="https://www.atmia.com/" target="_blank" rel="noopener noreferrer">ATM Industry Association</a></li>
            </ul>
        `
        }
    },
];